import React, {Component} from 'react';
import useFeatureFlag from "../../hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "../../constants/configurationKeys";
import {connect} from 'react-redux';
import { Redirect } from 'react-router-dom';
import AdvancedDisbursementsList from "../../components/AdvancedDisbursements/advancedDisbursementsList";
import _ from 'lodash';
import {
    changeAdvancedDisbursementsListSettings, clearAdvanceDisbursementsFilters
} from "../../actions/advancedDisbursementsList";
import {
    changeAdvanceDisbursementsStoreSettings,
    getAdvanceDisbursementsDueForPayment,
    getAdvanceDisbursementsStatementMessages,
    getAdvanceDisbursementsStatuses,
    getAdvanceDisbursementsRejectionReasons,
    getAllAdvancedDisbursements,
    getAllAdvancedDisbursementsSuggestions,
    receiveAllAdvancedDisbursements
} from "../../actions/advancedDisbursements";
import {changeActiveTab} from "../../actions/applicationPolicy";
import { push } from 'connected-react-router'
import {getCaseTypes} from "../../actions/caseTypes";
import {requestGetApplicationStatuses} from "../../actions/applicationStatuses";
import {isAragUser, isSolicitorUser, getArrayPamaterer} from "../../helpers/functions";
import BASE_URL from "../../cycles/variables";

import {
    ADVANCE_DISBURSEMENTS_PROCESSING_FILTER_STATUS_MACHINE_NAME, ADVANCE_DISBURSEMENTS_PAID_PART_SETTLED_STATUSES, CURRENCY
} from "../../helpers/variables";
import generatePolicyADStatement from "../../helpers/generatePolicyADStatement";
import {getADStatementLegalEntity, isGplFirm} from "../../helpers/advanceDisbursementsUtils";
import {requestGetSolicitorDetails} from "../../actions/manageSolicitorAccount";

class AdvancedDisbursementsListHOC extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount(){
        let parameters = this.getRequestParameters(this.props);
        this.props.getAllAdvancedDisbursements(parameters);
        this.props.getAdvanceDisbursementsStatuses();
        this.props.getAdvanceDisbursementsRejectionReasons();
        this.props.requestGetCaseTypes();
        if(isAragUser(this.props.loggedInUserRoles)){
            this.props.requestGetApplicationStatuses();
        }

        if(isSolicitorUser(this.props.loggedInUserRoles)){
            this.props.getSolicitorDetails(this.props.loggedInUserId)
        }


        this.props.getAdvanceDisbursementsStatementMessages();
    }

    componentWillReceiveProps(nextProps){
        clearTimeout(this.askServer);
        if(
            (
                this.props.advancedDisbursementsList.page !== nextProps.advancedDisbursementsList.page
                || this.props.advancedDisbursementsList.statusFilter !== nextProps.advancedDisbursementsList.statusFilter
                || this.props.advancedDisbursementsList.textFilter !== nextProps.advancedDisbursementsList.textFilter
                || this.props.advancedDisbursementsList.viewAmount !== nextProps.advancedDisbursementsList.viewAmount
                || this.props.advancedDisbursementsList.wasFilterButtonPressed && !nextProps.advancedDisbursementsList.wasFilterButtonPressed
            )
        ){
            let parameters = this.getRequestParameters(nextProps);
            if(this.props.advancedDisbursementsList.textFilter!==nextProps.advancedDisbursementsList.textFilter && nextProps.advancedDisbursementsList.textFilter!==''){
                parameters.offset = 0;
                parameters.limit = 5;
                this.askServer = setTimeout(()=>{this.props.getAllAdvancedDisbursementsSuggestions(parameters)},150);
            }else {
                this.props.getAllAdvancedDisbursements(parameters);
            }
        }

        if(
            this.props.fetchingADDueForPayment && !nextProps.fetchingADDueForPayment
            && !nextProps.fetchAdsDueForPaymentErrorMessage
        ) {
            const pdfMake = require('pdfmake/build/pdfmake.js');
            const pdfFonts = require('pdfmake/build/vfs_fonts.js');
            pdfMake.vfs = pdfFonts.pdfMake.vfs;

            //calculate the targeted lawsys that the statement is for
            let lawsys = {lawsysName: "", addressLine1: "", postCode: ""};
            // WI 100256 - the statement is for one firm, so the firm's ARAG Provider decides the entity.
            let isGpl = false;
            if(isSolicitorUser(this.props.loggedInUserRoles)){
                lawsys = {
                    lawsysName: this.props.solicitorDetails.lawsysName,
                    addressLine1: this.props.solicitorDetails.addressLine1,
                    postCode: this.props.solicitorDetails.postCode
                };
                isGpl = isGplFirm(this.props.solicitorDetails);
            } else if(
                isAragUser(this.props.loggedInUserRoles)
                && nextProps.advancedDisbursementsList.selectedFirms.length === 1
            ) {
                // the selected option carries the firm's details from the firm search
                const selectedFirm = nextProps.advancedDisbursementsList.selectedFirms[0];
                lawsys = {lawsysName: selectedFirm.label, addressLine1: selectedFirm.address, postCode: selectedFirm.postcode}
                isGpl = isGplFirm(selectedFirm);
            }


            const legalEntity = getADStatementLegalEntity(
                this.props.statementMessages, isGpl);
            const data = {
                advancedDisbursements: nextProps.advancedDisbursementsDueForPayment,
                lawsysFirm: lawsys,
                statementMessages: legalEntity.statementMessages,
                legalEntityName: legalEntity.legalEntityName
            };
            const generatedStatement =  pdfMake.createPdf(generatePolicyADStatement(data));
            const fileName = `Advance_Disbursements_Statement.pdf`;
            generatedStatement.download(fileName)
        }
    }

    getRequestParameters= (props) => {
        const currentPage = parseInt(props.advancedDisbursementsList.page);
        const calcOffset = props.advancedDisbursementsList.viewAmount*(currentPage -1);
        let paymentInstructionId = null;
        let selectedAdStatus = [...props.advancedDisbursementsList.selectedStatuses];
        if (
            selectedAdStatus.find(e => e.value ===  ADVANCE_DISBURSEMENTS_PROCESSING_FILTER_STATUS_MACHINE_NAME)
        ){
            const approvedStatus = props.advanceDisbursementsStatuses.find(e => e.machineName === 'approved');

            if(
                approvedStatus
                && selectedAdStatus.find(e => e.value.toString() ===  approvedStatus.id.toString())
            ) {
                paymentInstructionId = 0;
            } else {
                paymentInstructionId = -1;
            }

            if(approvedStatus){
                selectedAdStatus = selectedAdStatus
                    .map(e => e.value === ADVANCE_DISBURSEMENTS_PROCESSING_FILTER_STATUS_MACHINE_NAME ?
                        {...e, value: approvedStatus.id}
                        :
                        e
                    )
            }
        }

        return {
            limit: parseInt(props.advancedDisbursementsList.viewAmount),
            offset: calcOffset>0? calcOffset:0,
            search: props.advancedDisbursementsList.textFilter === '' ? null : props.advancedDisbursementsList.textFilter,
            minAmount: props.advancedDisbursementsList.amountFrom? props.advancedDisbursementsList.amountFrom: null,
            maxAmount: props.advancedDisbursementsList.amountTo? props.advancedDisbursementsList.amountTo: null ,
            selectedCaseTypes: props.advancedDisbursementsList.selectedCaseTypes,
            selectedSubCaseTypes: props.advancedDisbursementsList.selectedSubCaseTypes,
            selectedFirms: props.advancedDisbursementsList.selectedFirms,
            selectedPolicyStatuses: props.advancedDisbursementsList.selectedPolicyStatuses,
            selectedStatuses: selectedAdStatus,
            paymentInstructionId: paymentInstructionId
        };
    };

    _getFilterByStatusOptions = () => {
        const options =  this.props.advanceDisbursementsStatuses.map(i => ({value: i.id, label: i.name}));
        options.push({value: ADVANCE_DISBURSEMENTS_PROCESSING_FILTER_STATUS_MACHINE_NAME, label: 'Processing'});
        return options;
    };
    _changeTableViewOptions = (evt) => {
        this.props.changeStoreSettings({
            key: "viewAmount",
            value: evt.target.value
        });
    };


    //function that handles the row selection for the advanced disbursements table
    _handleAdSelect = (policyId) => {
        this.props.push('/application-and-policies/application-policy/' + policyId);
        this.props.changeActiveTab('advancedDisbursements')
    };

    //changes ad page
    _changeAdvancedDisbursementsPage = (name, value) => {
        this.props.changeStoreSettings({
            key:name,
            value: value
        });
    };

    _onAdSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
        if (method === 'enter' || method === 'click' ){
            let newValue = '';
            if(suggestion.applicationId !=='' && suggestion.applicationId!==0){
                newValue = suggestion.aragReference;
            }
            let payload = {
                body: {
                    data: [suggestion],
                    limit:0,
                    offset:0,
                    totalAppliedRecords: this.props.aDTotalAppliedRecords,
                    totalAppliedValue: this.props.aDTotalAppliedValue,
                    totalApprovedRecords: this.props.aDTotalApprovedRecords,
                    totalApprovedValue: this.props.aDTotalApprovedValue,
                    totalRecords: this.props.aDTotalRecords,
                    totalValue: this.props.aDTotalValue
                }
            };
            this.props.receiveAllAdvancedDisbursements(payload);
            this.props.changeStoreSettings({
                key: 'textFilter',
                value: newValue? newValue.toString(): ''
            });
            this.props.changeStoreSettings({
                key: 'textFilter',
                value: newValue? newValue.toString(): ''
            });
            this.props.changeAdvanceDisbursementsStoreSettings({
               key: 'advancedDisbursements',
               value: [suggestion]
            });
        }
    };

    _handleAutosuggestButton = (suggestion) => {
        let parameters = this.getRequestParameters(this.props);
        this.props.getAllAdvancedDisbursements(parameters);
    };

    //===========================//

    _handleInputChange = (evt) => {
        this.props.changeStoreSettings({
            key: evt.target.name,
            value: evt.target.value
        })
    };

    _filterByRange = () => {
        this.props.changeStoreSettings({key: 'wasFilterButtonPressed', value: true});
        let parameters = this.getRequestParameters(this.props);
        this.props.getAllAdvancedDisbursements(parameters);
    };

    clearFilters = () => {
        this.props.clearAdvanceDisbursementsFilters();
        this.props.getAllAdvancedDisbursements({
            limit: parseInt(this.props.advancedDisbursementsList.viewAmount),
            offset: 0,
            search: null,
            minAmount: null,
            maxAmount: null,
            selectedCaseTypes: [],
            selectedSubCaseTypes: [],
            selectedFirms: [],
            selectedPolicyStatuses: [],
            selectedStatuses: [],
            paymentInstructionId: null
        });
    };

    getSubCaseTypesOptions = () => {
        return this.props.caseTypes
            .filter(ct => !!this.props.advancedDisbursementsList.selectedCaseTypes.find(sel => sel.value === ct.id))
            .reduce((acc, current) =>  [
                ...acc,
                ...current.subCaseTypes.map(
                    type => ({value: type.id, label: type.name, machineName: type.machineName})
                )
            ], [])
    };

    onPrintStatement = () => {
        // WI: statement download disabled for solicitors - the button is disabled, but guard here too so no request can fire if triggered another way.
        if (isSolicitorUser(this.props.loggedInUserRoles)) {
            return;
        }

        const paidPartSettledAdStatuses = this.props.advanceDisbursementsStatuses.filter(status => ADVANCE_DISBURSEMENTS_PAID_PART_SETTLED_STATUSES.includes(status.machineName));
        let selectedAdCaseTypes = this.props.advancedDisbursementsList.selectedCaseTypes;
        let selectedAdPolicyStatuses = this.props.advancedDisbursementsList.selectedPolicyStatuses;
        let lawsysId = "";
        if(!paidPartSettledAdStatuses){
            return null;
        }

        if(
            isAragUser(this.props.loggedInUserRoles)
            && this.props.advancedDisbursementsList.selectedFirms.length === 1
        ){
            lawsysId = this.props.advancedDisbursementsList.selectedFirms[0].value
        } else {
            return ;
        }
    
        // Collect all IDs for ADs paid and oustanding statuses to be included in the statement
        const paidPartSettledAdStatusesIds = paidPartSettledAdStatuses.map(status => status.id);
        const caseTypesIds = selectedAdCaseTypes.map(status => status.value);
        const policyStatusesIds = selectedAdPolicyStatuses.map(status => status.value);

        this.props.getAdvanceDisbursementsDueForPayment({
            paidPartSettledAdStatusesIds,
            lawsysId,
            caseTypesIds,
            policyStatusesIds,
        })
    };

    onExportExcel = () => {
        const params = this.getRequestParameters(this.props);

        const base = `${BASE_URL}api/AdvanceDisbursements/disbursements/export?limit=0&offset=0`;
        const query =
            (params.paymentInstructionId !== null ? (`&PaymentInstructionId=${params.paymentInstructionId}`) : '') +
            (params.minAmount && (params.minAmount !== 0) ? (`&minAmount=${params.minAmount}`) : '') +
            (params.maxAmount && (params.maxAmount !== 0) ? (`&maxAmount=${params.maxAmount}`) : '') +
            (params.search ? (`&search=${encodeURIComponent(params.search)}`) : '') +
            (getArrayPamaterer(params.selectedFirms, 'lawsysIds') ? `&${getArrayPamaterer(params.selectedFirms, 'lawsysIds')}` : '') +
            (getArrayPamaterer(params.selectedPolicyStatuses, 'policyStatusIds') ? `&${getArrayPamaterer(params.selectedPolicyStatuses, 'policyStatusIds')}` : '') +
            (getArrayPamaterer(params.selectedStatuses, 'statusIds') ? `&${getArrayPamaterer(params.selectedStatuses, 'statusIds')}` : '') +
            (getArrayPamaterer(params.selectedCaseTypes, 'caseTypesIds') ? `&${getArrayPamaterer(params.selectedCaseTypes, 'caseTypesIds')}` : '') +
            (getArrayPamaterer(params.selectedSubCaseTypes, 'subCaseTypesIds') ? `&${getArrayPamaterer(params.selectedSubCaseTypes, 'subCaseTypesIds')}` : '');

        window.open(base + query, '_blank');
    };

    render() {
        return (
            <AdvancedDisbursementsList
                fetchingADDueForPayment={this.props.fetchingADDueForPayment}
                onPrintStatement={this.onPrintStatement}
                onExportExcel={this.onExportExcel}
                subCaseTypes={this.getSubCaseTypesOptions()}
                clearFilters={this.clearFilters}
                changeStoreSettings={this.props.changeStoreSettings}
                _filterByRange={this._filterByRange}
                _handleInputChange={this._handleInputChange}
                _handleAdSelect={this._handleAdSelect}
                _onAdSuggestionSelected={this._onAdSuggestionSelected}
                _handleAutosuggestButton={this._handleAutosuggestButton}
                fetchingAdvancedDisbursements={this.props.fetchingAdvancedDisbursements}
                _changeAdvancedDisbursementsPage={this._changeAdvancedDisbursementsPage}
                _changeTableViewOptions={this._changeTableViewOptions}
                advancedDisbursementsList={this.props.advancedDisbursementsList}
                filterByStatusOptions={this._getFilterByStatusOptions()}
                totalNumberOfApplied={this.props.aDTotalAppliedRecords}
                totalNumberOfAdvancedDisbursements={this.props.aDTotalRecords}
                totalNumberOfApproved={this.props.aDTotalApprovedRecords}
                totalValueOfAdvancedDisbursements={this.props.aDTotalValue}
                totalValueOfApplied={this.props.aDTotalAppliedValue}
                totalValueOfApproved={this.props.aDTotalApprovedValue}
                advancedDisbursements={this.props.advancedDisbursements}
                caseTypes={this.props.caseTypes}
                fetchingCaseTypes={this.props.fetchingCaseTypes}
                policyStatuses={this.props.policyStatuses}
                fetchingPolicyStatuses={this.props.fetchingPolicyStatuses}
                loggedInUserRoles={this.props.loggedInUserRoles}
                totalSettledRecords={this.props.totalSettledRecords}
                totalSettledValue={this.props.totalSettledValue}
                totalRejectedRecords={this.props.totalRejectedRecords}
                totalRejectedValue={this.props.totalRejectedValue}
                totalProcessingRecords={this.props.totalProcessingRecords}
                totalProcessingValue={this.props.totalProcessingValue}
                totalPaidRecords={this.props.totalPaidRecords}
                totalPaidValue={this.props.totalPaidValue}
                totalPartSettledRecords= {this.props.totalPartSettledRecords}
                totalPartSettledValue= {this.props.totalPartSettledValue}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        totalRejectedRecords: state.advancedDisbursements.totalRejectedRecords,
        totalRejectedValue: state.advancedDisbursements.totalRejectedValue,
        totalSettledRecords: state.advancedDisbursements.totalSettledRecords,
        totalSettledValue: state.advancedDisbursements.totalSettledValue,
        totalPartSettledRecords: state.advancedDisbursements.totalPartSettledRecords,
        totalPartSettledValue: state.advancedDisbursements.totalPartSettledValue,
        advancedDisbursementsList: state.advancedDisbursementsList,
        advancedDisbursements: state.advancedDisbursements.advancedDisbursements,
        advanceDisbursementsStatuses: state.advancedDisbursements.advanceDisbursementsStatuses,
        fetchingAdvancedDisbursements: state.advancedDisbursements.fetching,
        advanceDisbursementsRejectionReasons: state.advancedDisbursements.advanceDisbursementsRejectionReasons,
        aDTotalAppliedRecords: state.advancedDisbursements.totalAppliedRecords,
        aDTotalAppliedValue: state.advancedDisbursements.totalAppliedValue,
        aDTotalApprovedRecords: state.advancedDisbursements.totalApprovedRecords,
        aDTotalApprovedValue: state.advancedDisbursements.totalApprovedValue,
        aDTotalRecords: state.advancedDisbursements.totalRecords,
        aDTotalValue: state.advancedDisbursements.totalValue,
        totalProcessingRecords: state.advancedDisbursements.totalProcessingRecords,
        totalProcessingValue: state.advancedDisbursements.totalProcessingValue,
        totalPaidRecords: state.advancedDisbursements.totalPaidRecords,
        totalPaidValue: state.advancedDisbursements.totalPaidValue,
        caseTypes: state.caseTypes.cases,
        fetchingCaseTypes: state.caseTypes.fetching,
        policyStatuses: state.applicationStatuses.statuses,
        fetchingPolicyStatuses: state.applicationStatuses.fetching,
        loggedInUserRoles: state.user.loggedInUser.roles,
        loggedInUserId: state.user.loggedInUser.id,
        fetchingADDueForPayment: state.advancedDisbursements.fetchingADDueForPayment,
        fetchAdsDueForPaymentErrorMessage: state.advancedDisbursements.fetchAdsDueForPaymentErrorMessage,
        advancedDisbursementsDueForPayment: state.advancedDisbursements.advancedDisbursementsDueForPayment,
        statementMessages: state.advancedDisbursements.statementMessages,
        solicitorDetails: state.manageSolicitorAccount.solicitorData,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeStoreSettings: (payload) => {
            dispatch(changeAdvancedDisbursementsListSettings(payload))
        },
        getAllAdvancedDisbursements: (payload) => {
            dispatch(getAllAdvancedDisbursements(payload))
        },
        receiveAllAdvancedDisbursements: (payload) => {
            dispatch(receiveAllAdvancedDisbursements(payload))
        },
        getAllAdvancedDisbursementsSuggestions: (payload) => {
            dispatch(getAllAdvancedDisbursementsSuggestions(payload))
        },
        changeAdvanceDisbursementsStoreSettings: (payload) => {
            dispatch(changeAdvanceDisbursementsStoreSettings(payload))
        },
        changeActiveTab: (tab) => {
            dispatch(changeActiveTab(tab))
        },
        push: (url) => {
            dispatch(push(url))
        },
        getAdvanceDisbursementsStatuses: () => {
            dispatch(getAdvanceDisbursementsStatuses())
        },
        getAdvanceDisbursementsRejectionReasons: () => {
            dispatch(getAdvanceDisbursementsRejectionReasons())
        },
        requestGetCaseTypes: () => {
            dispatch(getCaseTypes())
        },
        requestGetApplicationStatuses: () => {
            dispatch(requestGetApplicationStatuses())
        },
        clearAdvanceDisbursementsFilters: (payload) => {
            dispatch(clearAdvanceDisbursementsFilters(payload))
        },
        getAdvanceDisbursementsDueForPayment: (payload) => {
            dispatch(getAdvanceDisbursementsDueForPayment(payload))
        },
        getAdvanceDisbursementsStatementMessages: (payload) => {
            dispatch(getAdvanceDisbursementsStatementMessages(payload))
        },
        getSolicitorDetails: (id) => {
            dispatch(requestGetSolicitorDetails(id))
        }
    }
};

const ConnectedAdvancedDisbursementsListHOC = connect(mapStateToProps, mapDispatchToProps)(AdvancedDisbursementsListHOC);

const AdvancedDisbursementsListHOCWithFeatureFlag = (props) => {
    const advanceDisbursementsEnabled = useFeatureFlag(FEATURE_FLAGS.ADVANCE_DISBURSEMENTS_ENABLED);
    if (!advanceDisbursementsEnabled) return <Redirect to="/" />;
    return <ConnectedAdvancedDisbursementsListHOC {...props} />;
};

export default AdvancedDisbursementsListHOCWithFeatureFlag;
